import "./ClaimSearchResults.scss";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Chip,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent
} from "@mui/material";
import { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { GridLoader, ScaleLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { useState } from "react";
import { motion } from "framer-motion";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { useTranslation } from "react-i18next";

const ClaimSearchResults = ({ risks, handleRiskCoverSelect, claimType }) => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [currentRiskPage, setCurrentRiskPage] = useState(0);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });

  const handleRiskPageChange = (event, newPage) => {
    setCurrentRiskPage(newPage);
  };

  const slicedRisks = risks?.slice(
    currentRiskPage * rowsPerPage,
    currentRiskPage * rowsPerPage + rowsPerPage
  );
  const handleRiskRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 3));
    setCurrentRiskPage(0);
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteNumGen") {

      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };

  return (
    <div className="claim-search-results">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="claim-search-results-wrapper">
          {slicedRisks?.length > 0 &&
            <div className="table-content">
              <TableContainer
                component={Paper}
                sx={{ border: 'none', boxShadow: 'none' }}
                className="table-container">
                <Table sx={{ width: '100%', border: 'none' }}>
                  <TableHead className="tablehead">
                    <TableRow className="tablerow">
                      <TableCell className="table-cell center" style={{ maxWidth: '50px' }}>
                        #
                      </TableCell>
                      <TableCell className="table-cell left" style={{ maxWidth: '250px' }}>
                        <span>{t('riskNote').toUpperCase()}</span>
                      </TableCell>
                      <TableCell className="table-cell left" style={{ width: 'auto' }}>
                        <span>{t('details').toUpperCase()}</span>
                      </TableCell>
                      <TableCell className="table-cell left" style={{ maxWidth: '400px' }}>
                        <span>{t('selectCover').toUpperCase()}</span>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="tablebody">
                    {slicedRisks?.map((row, index) => (
                      <TableRow key={`${row?._id}_${index}`} className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: '50px' }}>
                          <span>{currentRiskPage * rowsPerPage + index + 1}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: '250px' }}>
                          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            <span className="sub-title">{row?.pr_risk_note_no}</span>
                            {row?.pl_no && <span className="sub-title xrsmall soft" style={{ fontSize: "10px" }}>{`${t('policyNo')} : ${row?.pl_no}`}</span>}
                            <span className="sub-title xrsmall soft" style={{ fontSize: "10px" }}>{row?.product_name_xx}</span>
                          </div>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: 'auto' }}>
                          <span className="sub-title">{`${t('insured')} : ${row?.insured_details_xx?.ent_name}`}</span>
                          <span className="sub-title">{`${t('carrier')} : ${row?.carrier_details_xx?.ent_alias}`}</span>
                          {row?.sc_view_xx === "motor" && <span className="sub-title xrsmall">{`${t('regnNo')} : ${row?.pr_vehicle_regn}`}</span>}
                          {row?.sc_view_xx === "motor" && <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${t('model')} : ${row?.vehicle_model_xx}`}</span>}
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: '400px' }}>
                          <div className="cover-chips">
                            {row?.risk_covers_xx.map((cover, index) => (
                              <Chip key={`${cover?._id}_${index}`} label={`Select ${cover.cover_name_xx} ${row?.pl_product_code} cover`}
                                onClick={() => {
                                  try {
                                    handleRiskCoverSelect(row?.pl_no,
                                      {
                                        ...cover,
                                        risk_note_no: row?.pl_risk_note_no,
                                        insured_name_xx: row?.insured_details_xx?.ent_name,
                                        carrier_name_xx: row?.carrier_details_xx?.ent_name,
                                        branch_code: row?.pl_biz_unit,
                                        product_code: row?.pl_product_code,
                                        term_code: row?.pl_term_code,
                                        policy_docid: row?.pr_policy_docid,
                                        mc_code: cover?.pr_mc_code,
                                        sc_code: cover?.pr_sc_code,
                                        risk_docid: row?._id
                                      })
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                className="single-cover" />
                            ))}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {risks?.length > rowsPerPage &&
                  <TablePagination
                    rowsPerPageOptions={[3]}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleRiskRowsPerPage}
                    component="div"
                    count={risks?.length}
                    rows={risks}
                    page={currentRiskPage}
                    onPageChange={handleRiskPageChange}
                  />}
              </TableContainer>
            </div>}
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog
        open={isNotifyDialogOpen}
        onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* end of adding organization unit */}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {/* end of adding organization unit */}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default ClaimSearchResults;
